/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Detail_No_DescriptionInputs */

const en_ticket_detail_no_description = /** @type {(inputs: Ticket_Detail_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description provided.`)
};

const ja_ticket_detail_no_description = /** @type {(inputs: Ticket_Detail_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明はありません。`)
};

const fr_ticket_detail_no_description = /** @type {(inputs: Ticket_Detail_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune description fournie.`)
};

const de_ticket_detail_no_description = /** @type {(inputs: Ticket_Detail_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beschreibung vorhanden.`)
};

/**
* | output |
* | --- |
* | "No description provided." |
*
* @param {Ticket_Detail_No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_detail_no_description = /** @type {((inputs?: Ticket_Detail_No_DescriptionInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Detail_No_DescriptionInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_detail_no_description(inputs)
	if (locale === "ja") return ja_ticket_detail_no_description(inputs)
	if (locale === "fr") return fr_ticket_detail_no_description(inputs)
	return de_ticket_detail_no_description(inputs)
});